import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Navbar from '../components/navbar'
import ContactContent from '../components/contactContent';
import Team from '../components/team';
import Contact from '../components/contact';
import Subscribe from '../components/subscribe';
import Footer from '../components/footer';

const ContactPage = ({ history }) => {

/*     const { t } = useTranslation(); */

    useEffect(() => {
        window.scrollTo(0, 0);
    })

    return (
        <div>
			{/* Navbar Component*/}
			<Navbar/>

			{/* About Component*/}
			<ContactContent />

			{/*Team Component*/}
			<Team />

			{/*Contact Component*/}
			<Contact />

			{/*Subscription Component*/}
			<Subscribe />
            
            {/*copy-right-section*/}
            <Footer />
            {/*end copy right section*/}
        </div>
    );
}

export default withRouter(ContactPage);


// WEBPACK FOOTER //
// ./src/pages/contact-page.js